import React from "react";
import { useTranslation } from "next-export-i18n";

import LineArrow from "@/src/svg/line-arrow-5";

const HeroArea = () => {
    const { t } = useTranslation();

    return (
        <>
            <section
                className="platform platform__tp-hero-area"
                style={{
                    backgroundImage: `url(/assets/img/case-studies/case-studies-header.jpg)`,
                }}
            >
                <div className="container">
                    <h3 className="platform__title">
                        {t("case_studies.title.secondary")}{" "}
                        {/* <span className="platform__title-primary">
                            {t("case_studies.title.primary")}
                        </span> */}
                        <span className="title-right-shape">
                            <LineArrow />
                        </span>
                    </h3>
                    {/* <p className="platform__description">
                        {t("case_studies.subtitle")}
                    </p> */}
                </div>
            </section>
        </>
    );
};

export default HeroArea;
